import { httpsCallable, httpsCallableFromURL } from 'firebase/functions';
import { functions } from '../config/firebase';

const EXTRACT_LISTING_IMPORT_TIMEOUT_MS = 520_000;
const callableOptions = { timeout: EXTRACT_LISTING_IMPORT_TIMEOUT_MS };

function getExtractListingImportCallable() {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const url = `${window.location.origin}/__fb_functions/extractListingImport`;
    return httpsCallableFromURL(functions, url, callableOptions);
  }
  return httpsCallable(functions, 'extractListingImport', callableOptions);
}

/**
 * @param {{ listingUrl?: string, listingText?: string, fileBase64?: string, fileName?: string, locale?: string }} params
 * @returns {Promise<{
 *   fields: Record<string, string>,
 *   warnings: string[],
 *   urlFetchStatus: 'ok'|'blocked'|'failed'|'skipped'|'invalid',
 *   extractedFieldKeys: string[],
 *   advancedExpenses: boolean,
 *   needsMoreContent: boolean,
 * }>}
 */
export async function extractListingImport(params) {
  const fn = getExtractListingImportCallable();
  const res = await fn({
    listingUrl: params.listingUrl || '',
    listingText: params.listingText || '',
    fileBase64: params.fileBase64 || undefined,
    fileName: params.fileName || undefined,
    locale: params.locale === 'en' ? 'en' : 'fr',
  });
  return res.data;
}
